// Vendored from capsens-suitability-questionnaire gem (v0.12.0)
// Original files used Sprockets directives (//= require_self, //= require_directory)

let CSQ = {};

CSQ.helpers = {
  getQueryStringParameter: (parameterName) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(parameterName);
  },

  clearInputField: (inputElement) => {
    if (inputElement.type === 'radio' || inputElement.type === 'checkbox') {
      inputElement.checked = false;
    } else {
      inputElement.value = null;
    }
  },
};

// --- steps/knowledge.js ---
document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('csq-questionnaire-form');
  const step = CSQ.helpers.getQueryStringParameter('id');

  if (form === null || step !== 'knowledge') {
    return;
  }

  const investmentsInFinancialInstruments = form.querySelector(
    '#csq-investments-in-financial-instruments'
  );
  const financialInstrumentsKnowledgeDetails = form.querySelector(
    '#csq-financial-instruments-knowledge-details'
  );

  investmentsInFinancialInstruments.addEventListener('change', (e) => {
    if (e.target.tagName !== 'INPUT' || e.target.type !== 'radio') {
      return;
    }

    if (e.target.value === 'false' && e.target.checked) {
      financialInstrumentsKnowledgeDetails.style.display = 'none';
      financialInstrumentsKnowledgeDetails
        .querySelectorAll('input, textarea')
        .forEach(CSQ.helpers.clearInputField);
    } else {
      financialInstrumentsKnowledgeDetails.style.removeProperty('display');
    }
  });

  const crowdfundingSkills = form.querySelector('#csq-crowdfunding-skills');
  const crowdfundingInvestmentsDetails = form.querySelector(
    '#csq-crowdfunding-investments-details'
  );

  crowdfundingSkills.addEventListener('change', (e) => {
    if (e.target.tagName !== 'INPUT' || e.target.type !== 'radio') {
      return;
    }

    if (e.target.value === 'false' && e.target.checked) {
      crowdfundingInvestmentsDetails.style.display = 'none';
      crowdfundingInvestmentsDetails
        .querySelectorAll('input, textarea')
        .forEach(CSQ.helpers.clearInputField);
    } else {
      crowdfundingInvestmentsDetails.style.removeProperty('display');
    }
  });
}, false);

// --- steps/modal.js ---
document.addEventListener('DOMContentLoaded', () => {
  const modals = document.querySelectorAll('[data-csq-modal]');

  if (modals) {
    const body = document.querySelector('body');
    const bgElement = document.createElement('div');

    modals.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();

        const modal = document.getElementById(trigger.dataset['csqModal']);

        body.after(bgElement);
        modal.classList.add('csq-modal-open');

        bgElement.classList.add('csq-modal-bg');
        bgElement.classList.add('csq-modal-close');

        const closes = document.querySelectorAll('.csq-modal-close');

        closes.forEach((close) => {
          close.addEventListener('click', (event) => {
            event.preventDefault();

            bgElement.remove();

            modal.classList.remove('csq-modal-open');
          });
        });
      });
    });
  }
}, false);

// --- steps/objectives_and_financial_situation.js ---
document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('csq-questionnaire-form');
  const step = CSQ.helpers.getQueryStringParameter('id');

  if (form === null || step !== 'objectives_and_financial_situation') {
    return;
  }

  const hasInvestmentDurabilityExpectations = form.querySelector(
    '#csq-has-investment-durability-expectations'
  );
  const investmentDurabilityExpectations = form.querySelector(
    '#csq-investment-durability-expectations'
  );

  hasInvestmentDurabilityExpectations.addEventListener('change', (e) => {
    if (e.target.tagName !== 'INPUT' || e.target.type !== 'radio') {
      return;
    }

    if (e.target.value === 'false' && e.target.checked) {
      investmentDurabilityExpectations.style.display = 'none';
      investmentDurabilityExpectations
        .querySelectorAll('input, textarea')
        .forEach(CSQ.helpers.clearInputField);
    } else {
      investmentDurabilityExpectations.style.removeProperty('display');
    }
  });
}, false);

// --- steps/step_dropdown.js ---
document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('csq-questionnaire-form');

  if (form === null) {
    return;
  }

  const dropdownButton = document.getElementById('step-toggle-button');
  const dropdownList = document.getElementById('step-toggle-menu');

  window.addEventListener('click', (e) => {
    if (
      e.target.id === 'step-toggle-menu' ||
      e.target.closest('#step-toggle-menu') !== null ||
      dropdownList.style.display !== 'block'
    ) {
      return;
    }

    dropdownList.style.display = 'none';
  });

  dropdownButton.addEventListener('click', (e) => {
    e.stopPropagation();

    if (dropdownList.style.display === 'none') {
      dropdownList.style.display = 'block';
    } else {
      dropdownList.style.display = 'none';
    }
  });
});
